import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import Typography from '@mui/material/Typography';
import { MouseEvent } from 'react';
import theme from '../../theme';

interface ICarType {
    displayName: string;
    displayOrder: number;
    iconType: string;
    iconUrl: string;
    url: string;
}

interface ICarTypeSelectorProps {
    carType: ICarType;
    handleClick: (href: string, cardName: string) => (e: MouseEvent<HTMLAnchorElement>) => void;
}

const CarTypeSelector = ({ carType: { displayName, url, iconUrl }, handleClick }: ICarTypeSelectorProps) => (
    <Card
        variant="outlined"
        sx={{
            ':focus-within': {
                outline: '2px solid',
                outlineColor: theme.palette.primary.main,
                outlineStyle: 'auto',
            },
        }}
    >
        <CardActionArea
            href={url}
            onClick={handleClick(url, displayName)}
            data-testid="shop-by-type-tile-link"
            sx={{
                padding: { xs: '0.75rem 0.25rem 0.5rem', sm: '1rem 0.75rem 0.75rem' },
            }}
        >
            <Box
                component="img"
                sx={{
                    width: '100%',
                    height: 'auto',
                }}
                src={iconUrl}
                alt={displayName}
                data-testid="shop-by-type-tile-image"
            />
            <Typography
                color="text.primary"
                sx={{
                    textAlign: 'center',
                    typography: { xs: 'body2', sm: 'body1' },
                    minHeight: '22px',
                }}
                data-testid="shop-by-type-tile-caption"
            >
                {displayName}
            </Typography>
        </CardActionArea>
    </Card>
);

export default CarTypeSelector;
